import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fe2c30a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "CabecalhoTabela",
  "data-testid": "CabecalhoTabela"
}
const _hoisted_2 = { class: "CabecalhoTabela__Informacoes" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "CabecalhoTabela__Responsaveis" }
const _hoisted_5 = { class: "CabecalhoTabela__TotalResponsaveis" }
const _hoisted_6 = { class: "CabecalhoTabela__Botoes" }

import { OGrupoAvatar } from "@/components/Gerais"
  import { EntidadeSimples } from "@/types/gerais"
  import Button from "primevue/button"
  import { computed } from "vue"
  import { useI18n } from "vue-i18n"

  interface Props {
    nomeDoGrupo: string
    usuariosResponsaveis: EntidadeSimples[]
    permissaoDeEdicao: boolean
  }

  interface Emissoes {
    (event: "aoDeletarGrupo"): void
    (event: "aoEditarGrupo"): void
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MCabecalhoTabelaGrupo',
  props: {
    nomeDoGrupo: null,
    usuariosResponsaveis: null,
    permissaoDeEdicao: { type: Boolean }
  },
  emits: ["aoDeletarGrupo", "aoEditarGrupo"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "aoDeletarGrupo"): void
    (event: "aoEditarGrupo"): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    nomeDoGrupo: string
    usuariosResponsaveis: EntidadeSimples[]
    permissaoDeEdicao: boolean
  }

  
  

  const { t } = useI18n()

  const quantidadeDeUsuariosResponsaveis = computed(() => {
    const quantidadeDeResponsaveis = props.usuariosResponsaveis.length || 0
    if (quantidadeDeResponsaveis === 1) {
      return t("umUsuarioResponsavel")
    } else {
      return `${quantidadeDeResponsaveis} ${t("usuariosResponsaveis")}`
    }
  })

  const deletarGrupoDeProjeto = (): void => {
    emitir("aoDeletarGrupo")
  }

  const editarGrupoDeProjeto = (): void => {
    emitir("aoEditarGrupo")
  }

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", {
        class: "CabecalhoTabela__Titulo",
        title: __props.nomeDoGrupo
      }, _toDisplayString(__props.nomeDoGrupo), 9, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(OGrupoAvatar), {
          avatares: __props.usuariosResponsaveis,
          "limitar-quantidade-em": 10
        }, null, 8, ["avatares"]),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(quantidadeDeUsuariosResponsaveis)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (__props.permissaoDeEdicao)
        ? (_openBlock(), _createBlock(_unref(Button), {
            key: 0,
            onClick: editarGrupoDeProjeto,
            class: "CabecalhoTabela__BotaoEditar",
            "data-testid": "CabecalhoTabela__BotaoEditar",
            icon: "pi pi-pencil",
            label: _unref(t)('editarGrupo'),
            outlined: ""
          }, null, 8, ["label"]))
        : _createCommentVNode("", true),
      (__props.permissaoDeEdicao)
        ? _withDirectives((_openBlock(), _createBlock(_unref(Button), {
            key: 1,
            onClick: deletarGrupoDeProjeto,
            class: "CabecalhoTabela__BotaoDeletar",
            "data-testid": "CabecalhoTabela__BotaoDeletar",
            icon: "pi pi-trash",
            outlined: ""
          }, null, 512)), [
            [
              _directive_tooltip,
              _unref(t)('deletarGrupoDeProjetos'),
              void 0,
              { top: true }
            ]
          ])
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})